export default "__VITE_ASSET__CL827YZF__"